import { change } from 'redux-form'
import { createSelector } from 'reselect'
import map from 'lodash/map'

/**
 *
 * Master select changes child selects value in redux form store
 *
 * @param {Object} flags - such as (sybmolCounter, modifies ...)
 * @param {Object} dynamicOptions - dynamicly changed options
 * @param {Function} dispatch
 *
 */
export const dependentSelectsCustonOnChange = (value, dispatch, flags = {}) => {
  const { modifies } = flags

  if (modifies) {
    const childSelectsKeys = Object.keys(modifies.field)

    childSelectsKeys.forEach((childSelectKey) => {
      const firstValue = modifies.field[childSelectKey].find(
        // ParentID <- is from dynamic fields (all child selects have ParentID)
        (curr) => (curr.ParentID || curr[modifies.modifierAlias || modifies.modifier]) === value,
      )

      const SelectedsValue = firstValue ? firstValue.ID : 1

      dispatch(change(modifies.form, childSelectKey, SelectedsValue))

      if (modifies.dependent) {
        dependentSelectsCustonOnChange(SelectedsValue, dispatch, { modifies: modifies.dependent })
      }
    })
  }
}

export const getAsyncValidatingProps = (asyncValidating) => ({
  icon: asyncValidating ? 'user' : undefined,
  loading: asyncValidating,
  iconPosition: asyncValidating ? 'left' : undefined,
})

export const formatOptions = createSelector(
  (data) => data,
  (options) =>
    map(options, ({ ID, Title, UR_Title, disabled, style, content }) => ({
      disabled,
      style,
      content,
      key: ID,
      value: ID,
      text: Title || UR_Title,
    })),
)

export const getSymbolsCountProps = (symbolCounter, value) => {
  if (symbolCounter) {
    return {
      label: {
        basic: true,
        content: value.length < 10 ? `0${value.length}` : value.length,
        width: 8,
      },
      labelPosition: 'right',
    }
  }
}
